export function ErrorPage() {
  return <h1>404</h1>;
}
